import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const Counter = ({ targetDateString }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const countDownDate = new Date(targetDateString).getTime();

        const calculateTimeLeft = () => {
            const now = new Date().getTime();
            const distance = countDownDate - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setTimeLeft({ days, hours, minutes, seconds });
            } else {
                // Timer reached zero
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        // Call it immediately once
        calculateTimeLeft();
        
        // Setup interval
        const timerInterval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(timerInterval);
    }, [targetDateString]);

    return (
        <div className="timer">
            <div className="counter">
                <div className="days" id="dias">{timeLeft.days}</div>
                <div className="dotnumber">|</div>
                <div className="hours" id="horas">{timeLeft.hours}</div>
                <div className="dotnumber">|</div>
                <div className="minute" id="minutos">{timeLeft.minutes}</div>
            </div>
            <div className="countertext">
                <div>
                    <FormattedMessage id="eventCounterDays" defaultMessage="Días" />
                </div>
                <div>
                    <FormattedMessage id="eventCounterHours" defaultMessage="Hrs." />
                </div>
                <div>
                    <FormattedMessage id="eventCounterMinutes" defaultMessage="Min." />
                </div>
            </div>
        </div>
    );
};

export default Counter;
